import { AxiosError } from 'axios'
import QueryString from 'qs'
import useSWR from 'swr'

import { Lead } from './types'

export type GetAnyLeadResponse = {
  collection: Lead[]
  pagination: {
    counter: {
      limit: number
      total: number
    }
    cursors: {
      after: string
      before: string
    }
  }
}

export const useGetAnyLead = ({ is_spam = 0 }: { is_spam?: 0 | 1 }) => {
  const params = QueryString.stringify({
    limit: 0,
    page: 1,
    'filters[is_spam]': is_spam
  })

  const { data, isLoading, mutate, error } = useSWR<
    GetAnyLeadResponse,
    AxiosError
  >(`leads/search-v2?${params}`)

  return { data, isLoading, mutate, error }
}
